<template>
  <div class="app-footer">
    <footer style="padding-top:3rem; padding-bottom:0.3rem ">
      <div class="container">
        <div class="links-section">
          <div class="row mb-5">
            <div class="col-9 col-sm-9 col-md-9">
              <div class="row" style="display:flex">
                <div class="col-md-3">
                  <div class="is-header">
                    <h6 class>Brands</h6>
                  </div>
                  <div class="footer-links">
                    <ul>
                     
                      <li>
                        <router-link to="/peugeot">Peugeot</router-link>
                      </li>

                      <li>
                        <router-link to="/citroen">Citroën</router-link>
                      </li>
                         <!-- <li>
                        <router-link to="/mercedes/commercial">MB CV</router-link>
                      </li> -->
                       <li>
                        <router-link to="/mercedes/passenger">MB PV</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="is-header">
                    <h6 class>about us</h6>
                  </div>
                  <div class="footer-links">
                    <ul>
                      <li>
                        <router-link to="/about">About Company</router-link>
                      </li>
                        <li>
                        <router-link to="/terms">Terms & Conditions</router-link>
                      </li>
                      <li>
                        <router-link to="/privacy">Privacy</router-link>
                      </li>

                      <li>
                        <router-link to="/milestones">Key Milestones</router-link>
                      </li>
                      <li>
                        <router-link to="/awards">Awards</router-link>
                      </li>
                      <!-- <li>
                        <router-link to="/news">News</router-link>
                      </li> -->
                      <li>
                        <router-link to="/csr">CSR</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="is-header">
                    <h6 class>After-Sales</h6>
                  </div>
                  <div class="footer-links">
                    <ul>
                      <li>
                        <router-link to="/aftersales">After-Sales Service</router-link>
                      </li>
                      <li>
                        <router-link to="/aftersales">Workshop</router-link>
                      </li>

                      <li>
                        <router-link to="/aftersales">Spare Parts</router-link>
                      </li>
                      <li>
                        <router-link to="/aftersales">Warranty</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="is-header">
                    <h6 class>contact us</h6>
                  </div>
                  <div class="footer-links">
                    <ul>
                      <li>
                        <router-link to="/contact">Accra</router-link>
                      </li>
                      <li>
                        <router-link to="/contact">Tema</router-link>
                      </li>

                      <li>
                        <router-link to="/contact">Kumasi</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-3">
              <div class="row" style="display:flex">
                <div class="col-md-6">
                  <el-button type="info" class="footerbtninfo" style="border: 1.5px solid #BCBCBC;background:transparent" @click="contact">
                    BOOK AN APPOINTMENT
                    <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                  </el-button>
                </div>
               
              </div>
              <div>
                <a href="https://www.facebook.com/silverstarautogh/" class="fa fa-facebook"></a>
                 <a href="https://www.instagram.com/silverstargh/" class="fa fa-instagram"></a>
                  <a href="https://www.linkedin.com/company/silver-star-auto-limited" class="fa fa-linkedin"></a>
                   <a href="https://www.youtube.com/channel/UCmo5caOGws_iC2nf0YmHBtA?view_as=subscriber" class="fa fa-youtube"></a>


              </div>
            </div>

           
          </div>
        </div>

        <!-- <div class="copyright-section d-flex flex-row">
          <div>
            <p class="owner">&copy; Ultimate Supplies Limited {{ copyrightDate }}</p>
          </div>
          <div class="ml-auto">
            <p class="owner">
              Designed and developed by
              <a
                href="http://tribalhousestudios.com"
                class="tri"
                target="_blank"
              >Tribal House Studios</a>
            </p>
          </div>
        </div>-->
      </div>
      <div class="container">
        <div class="row" style="border-top:1px solid #707070">
          <div class="col-12 col-md-6" style="margin-top:1rem">
            <p class="owner">
          © 1996 - {{copyrightDate}} <span class="move"> Silver Star Auto Limited </span>
          <span class="move">|</span>
           <span class="move" @click="privacy"> Privacy Policy  </span> 
          
            </p>
          </div>
          <div class="col-12 col-md-6 "  style="">
            <p class="ownerdev">
              Designed and developed by
              <a
                href="http://tribalhousestudios.com"
                class="tri"
                target="_blank"
              >Tribal House Studios</a>
             
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
// var logo = require("../../assets/img/luex.png");
var date = new Date();

export default {
  name: "Footer",
  data() {
    return {
      copyrightDate:new Date().getFullYear()

      //  logo: logo,
    };
  },
  methods: {
    contact(){
       this.$router.push("/contact");
    },
    privacy(){
       this.$router.push("/privacy");
    },}
};
</script>
